import Swiper from 'swiper';
import { generate } from '../../../core/js/utils/componentUtils';
import { createGAEvent } from '../../../core/js/utils/analyticsUtils';
import { handleUtagEvent } from '../../../core/js/actions/initialActions';

const config = {
    name: 'carouselComponent',
    target: '.js-carousel',
    attachEvents: attachEvents
};

export function init(store, overrides = {}) {
    return generate(config, store, overrides);
}

export function attachEvents(store) {
    getCarousel(this.target, {}, store);
}

export function showOtherImages(swiper, store) {
    const swiperLocation = swiper.container[0];
    const $swiperLocationParent = $(swiperLocation).parent();

    $swiperLocationParent
        .find('.o-carousel--hidden')
            // eslint-disable-next-line func-names
            .each((function() {
                $(this).removeClass('o-carousel--hidden');
            })
        );
}

/**
 * Add Google analytics pagination tracking for next and previous buttons
 * We can't use slider callback functions for this because we don't want the
 * analytic event to fire on autoplay.
 * @param {object} store The redux store
 * @param  {string} pageType pageType
 * @param  {object} $target carousel
 */
function addGAEventsForNavigation(store, pageType, $target) {
    const $contentfulCarousel = $target.parent('.js-contentful-carousel');
    const gaEventPrev = createGAEvent(pageType, 'slider click', 'previous');
    const gaEventNext = createGAEvent(pageType, 'slider click', 'next');

    $contentfulCarousel.find('.js-carousel__button--next').on('click', () => {
        store.dispatch(handleUtagEvent(gaEventNext, 'link'));
    });

    $contentfulCarousel.find('.js-carousel__button--prev').on('click', () => {
        store.dispatch(handleUtagEvent(gaEventPrev, 'link'));
    });
}

/**
 * Turn on play/pause buttons
 * @param {object} store The redux store
 * @param  {object} $target carousel
 */
function addPlayPause(store, $target, pageType) {
    const $contentfulCarousel = $target.parent('.js-contentful-carousel');
    const $carouselPauseButton = $contentfulCarousel.find('.js-carousel__pause');
    const $carouselPlayButton = $contentfulCarousel.find('.js-carousel__play');
    const $carouselNavButton = $contentfulCarousel.find('.o-carousel__button');
    const $carouselSlides = $contentfulCarousel.find('.js-carousel__slide');
    const gaEventPlay = createGAEvent(pageType, 'slider click', 'play');
    const gaEventPause = createGAEvent(pageType, 'slider click', 'pause');

    $carouselSlides.on('mousedown', () => {
        // Already pauses on click. Adjusting play pause to reflect.
        $carouselPauseButton[0].setAttribute('hidden', true);
        $carouselPlayButton[0].removeAttribute('hidden');
    });

    $carouselNavButton.on('click', () => {
        // Already pauses on click. Adjusting play pause to reflect.
        $carouselPauseButton[0].setAttribute('hidden', true);
        $carouselPlayButton[0].removeAttribute('hidden');
    });

    $carouselPlayButton.on('click', () => {
        store.dispatch(handleUtagEvent(gaEventPlay, 'link'));

        $contentfulCarousel[0].swiper.startAutoplay();
        $carouselPlayButton[0].setAttribute('hidden', true);
        $carouselPauseButton[0].removeAttribute('hidden');
    });

    $carouselPauseButton.on('click', () => {
        store.dispatch(handleUtagEvent(gaEventPause, 'link'));

        $contentfulCarousel[0].swiper.stopAutoplay();
        $carouselPauseButton[0].setAttribute('hidden', true);
        $carouselPlayButton[0].removeAttribute('hidden');
    });

}

/**
 * Get a Swiper carousel
 * @param  {string} target '.js-selector' Target selector to create the Swiper carousel in
 * @param  {object} options {} Swiper options
 * @param {object} store The redux store
 *
 */
export function getCarousel(target, options = {}, store) {
    const pageType = _.get(store.getState(), 'core.pageType');

    _.forEach($(target), targetElem => {
        const $target = $(targetElem);

        // avoid creating a new swiper, if the target element no longer exists on the page
        // eslint-disable-next-line consistent-return
        if ($target.length === 0) { return; }

        // does an instance of swiper already exist for the target element?
        // eslint-disable-next-line consistent-return
        if ($target[0].swiper) { return $target[0].swiper; }

        let uuidClass;
        if (!$target.data('uuid')) {
            const uuid = Math.round(Math.random() * 99999);
            uuidClass = 'js-carousel-' + uuid;
            $target.data('uuid', uuid);
            $target.parent().addClass(uuidClass);
        }

        // Add google anlytics pagination tracking
        addGAEventsForNavigation(store, pageType, $target);

        const swiperOptions = _.merge(getDefaultOptions(target, uuidClass, store), options);

        // TODO:  UW-926 - hide bullets when there are less than 3 slides

        // eslint-disable-next-line consistent-return
        const currentSwiper = new Swiper(targetElem, swiperOptions);
        $target.parent()[0].swiper = currentSwiper;

        // Add Play/Pause functionality
        addPlayPause(store, $target, pageType);
        return currentSwiper;
    });
}

function getDefaultOptions(target, scopeClass = '', store) {
    const carouselClass = target.replace('.', '');
    const computedClass = scopeClass ? `.${scopeClass} .${carouselClass}` : `.${carouselClass}`;
    const autoPlayTiming = parseInt($(computedClass).data().autoPlayTiming, 10) * 1000;

    const isLoop = $(computedClass).data().isLoop === 'True' ? true : false;
    const stopAutoplayOnLast = !isLoop;

    return {
        wrapperClass: `${carouselClass}__inner`,
        slideClass: `${carouselClass}__slide`,
        bulletClass: 'o-carousel__bullet',
        bulletActiveClass: 'o-carousel__bullet--active',
        pagination: `${computedClass}__pagination`,
        paginationClickable: `${computedClass}__pagination`,
        nextButton: `${computedClass}__button--next`,
        prevButton: `${computedClass}__button--prev`,
        buttonDisabledClass: 'o-carousel__button--disabled',
        noSwiping: true,
        noSwipingClass: 'js-carousel--no-swiping',
        spaceBetween: 0,
        effect: 'slide',
        autoplay: autoPlayTiming,
        autoplayStopOnLast: stopAutoplayOnLast,
        speed: 500,
        loop: isLoop,
        setWrapperSize: true,
        runCallbacksOnInit: false,
        onInit: showOtherImages
    };
}
